<div class="container">
  <h1>{{'RVCs Generated by Helpdesk' | translate}}</h1>

  <section class="upload-section">
    <form #historyForm="ngForm" (ngSubmit)="filter()" class="upload-form">

      <div class="notes-input-wrapper">
        <label for="vin">{{'VIN' | translate}}</label>
        <input type="text" id="vin" name="vin" class="form-control"
               placeholder="{{'Enter 17-digit VIN' | translate}}"
               [(ngModel)]="formData.vin"
               minlength="17" maxlength="17"
               (input)="handleInput('vin', $event)">
        <div *ngIf="historyForm.controls['vin']?.hasError('pattern') && historyForm.controls['vin']?.dirty" class="validation-warning">
          {{'VIN validationn' | translate }}
        </div>
      </div>

      <div class="notes-input-wrapper">
        <label for="dealerCode">{{'DEALER CODE' | translate}}</label>
        <input type="text" id="dealerCode" name="dealercode" class="form-control"
               placeholder="{{'Enter Dealer Code' | translate}}"
               [(ngModel)]="formData.dealercode"
               [disabled]="userType === 'PTS_DEALER'"
               (input)="handleInput('dealercode', $event)">
        <div *ngIf="historyForm.controls['dealercode']?.hasError('pattern') && historyForm.controls['dealercode']?.dirty" class="validation-warning">
          {{'Dealer code validation' | translate}}
        </div>
      </div>

      <button type="submit" class="upload-btn"
              [disabled]="isFilterButtonDisabled">{{'Filter' | translate}}</button>

    </form>
  </section>

  <section class="version-history">
    <h2>{{'RVC History' | translate}}</h2>
    <table>
      <thead>
        <tr>
          <th>{{'VIN' | translate}}</th>
          <th>{{'DEALER CODE' | translate}}</th>
          <th>{{'RVC' | translate}}</th>
          <th>{{'CREATED ON' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="showloading">
          <td colspan="5" style="text-align: center; padding: 20px;">
              <div class="load">
                  <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="60" height="60" class="imgNoBorder">
              </div>
          </td>
        </tr>
        <tr *ngFor="let item of rvcData">
          <td>{{ item.vin }}</td>
          <td>{{ item.dealercode }}</td>
          <td>{{ item.rvc }}</td>
          <td>{{ item.createdTime | date:'yyyy-MM-dd h:mm a' }}</td>
        </tr>
        <tr *ngIf="receivedresult && rvcData.length === 0">
          <td colspan="4" style="text-align: center; padding: 20px; color: #777;">
            {{'No record' | translate }}
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</div>